import createSagaMiddleware, { END } from "@redux-saga/core";
import { applyMiddleware, createStore } from "redux";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { persistStore, persistReducer } from "redux-persist";
import rootReducer from "./reducers";
import { SagaStore, StoreConfig } from "types/state";

const persistConfig = {
  key: "root",
  storage: AsyncStorage,
  blacklist: ["loading", 'config'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default function configureStore(): StoreConfig {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(
    persistedReducer,
    applyMiddleware(sagaMiddleware)
  ) as unknown as SagaStore;
  const persistor = persistStore(store);

  store.runSaga = sagaMiddleware.run;
  store.close = () => store.dispatch(END);

  return { persistor, store };
}
